import { render } from "./AppInlineProfile.vue?vue&type=template&id=97d1ba86"
import script from "./AppInlineProfile.vue?vue&type=script&lang=js"
export * from "./AppInlineProfile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\kalmisto\\kalmisto-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__